module.exports = __webpack_public_path__ + "static/media/teygja_armretta.4813f884.png";